import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { setCurrentLang } from "../../../store/actions/Lang";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import history from "../../../routes/History";
import { updateURLocalization } from "utils/Shared";
import { candidatesPortalLink } from "utils/Redirections";
import logo from "../../../assets/images/image001 (1).png";
import "./Navbar.scss";

function Navbars(props) {
  const lang = useSelector((state) => state.locale.lang);
  const { messages } = props.intl;
  const dispatch = useDispatch();
  const switcher = (lang) => {
    updateURLocalization(lang === "ar" ? "en" : "ar");
    dispatch(setCurrentLang(lang === "ar" ? "en" : "ar"));
  };
  return (
    <React.Fragment>
      <Navbar expand="lg" className="nav_container py-2">
        <Container className="nav-container-width">
          <Link to="/">
            <img src={logo} alt="HRCom logo" className="navbar-logo" />
          </Link>
          {/* <div className="d-flex">
            <a
              href={candidatesPortalLink()}
              className="signNav text-white navItem px-3  medium_font mx-0 md-actions"
            >
              <button className=" light-btn-border signNav px-2 py-0 bold_font">
                {messages.jobSeekerTitle}
              </button>
            </a>
            <Link
              className="signNav text-white navItem px-3  medium_font mx-0 md-actions"
              to="/registration"
            >
              <button className="text-white signNav light-btn px-2  bold_font ">
                {messages.tryFree}
              </button>
              <small className="d-block text-center company-note ">
                {messages.shared.signUpNote}
              </small>
            </Link>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
          </div> */}

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav
              className="mx-auto d-flex align-items-center"
              activeKey={history.location.pathname}
            >
              {/* <Nav.Item>
                <Nav.Link href="/" className="navItem bold_font">
                  {messages.home}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="/About-us" className="navItem bold_font">
                  {messages.aboutUs}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="/products" className="navItem bold_font">
                  {messages.products}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="/pricing" className="navItem bold_font">
                  {messages.pricing}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="/Contact-us" className="navItem bold_font">
                  {messages.contactUs}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="/FAQ" className="navItem bold_font">
                  {messages.fqa}
                </Nav.Link>
              </Nav.Item> */}
            </Nav>
            <Nav>
              {/* <a
                href={candidatesPortalLink()}
                className="signNav text-white navItem px-3  medium_font mx-0 lg-actions"
              >
                <button className=" light-btn-border signNav px-4 py-3 bold_font">
                  {messages.jobSeekerTitle}
                </button>
              </a>
              <Link
                className="signNav text-white navItem px-3  medium_font mx-0 lg-actions"
                to="/registration"
              >
                <button className="text-white signNav light-btn mt-3 px-4 py-3 bold_font ">
                  {messages.tryFree}
                </button>
                <small className="d-block text-center">
                  {messages.shared.signUpNote}
                </small>
              </Link> */}
              {/* <Nav className="navItem text-dark bold_font">
                <Link
                  className="signNav bold_font navItem px-3 mx-0"
                  to="/companyLogin"
                >
                  {messages.signIn}
                </Link>
              </Nav> */}
              {/* <div className="border_right bold_font"></div> */}
              {/* <Nav.Link className="text-center nav-link d-flex align-items-center justify-content-center">
                <button
                  className="btn btn-link langBtn text-dark bold_font"
                  id="en"
                  onClick={() => switcher(lang)}
                >
                  {messages.langBtn}
                </button>
              </Nav.Link> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </React.Fragment>
  );
}

const HeaderComponent = injectIntl(Navbars);

export default HeaderComponent;
